import { BulkActionInstanceStatusInterface } from '@vendasta/bulk-actions';
import { interval, Observable, SchedulerLike, throwError } from 'rxjs';
import { share, startWith, switchMap } from 'rxjs/operators';

export interface ProgressReporter {
  getPolledStatus$(instanceId: string): Observable<BulkActionInstanceStatusInterface>;
}

export function withPolling<T>(
  request: () => Observable<T>,
  pollInterval = 5000,
  scheduler?: SchedulerLike,
): Observable<T> {
  if (pollInterval === 0 || !pollInterval) {
    return throwError(new Error('pollInterval must be positive'));
  }
  return interval(pollInterval, scheduler || undefined).pipe(
    startWith(0), // poll immediately
    switchMap(() => request()),
    share(),
  );
}
